/** `cents` is an integer (e.g. Stripe-style minor units). */
export function formatCentsAsUsd(cents: number): string {
  return (cents / 100).toFixed(2);
}
